webpackJsonp([211330298918620],{

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(40);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Optimistic Updates: Overview'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this section we\'ll update our application to immediately display tweets that we create at the top of the feed, and we\'ll also address some of the challenges that we need to solve for when performing these types of optimistic updates.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'At the end of this section your application will look like this (visually identical):'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'What are optimistic updates?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Optimistic updates are the act of displaying changes to data before the server has confirmed that the desired create, update or delete action was successful.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, when a user creates a tweet, it takes time for that request to be sent to the API server, get saved to the database, and make it back to the browser to confirm the tweet was created.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If an application chooses to wait until the server confirms the request before displaying the tweet, then it has a couple options for what type of experience to provide:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'One option is to display a "saving experience" to the user, and prevent them from interacting with the application further until the request comes back.'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Another is to submit the request, but make no changes to the application until the request comes back, at which point the data will suddenly "show up" in the application.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The first experience asks the user to wait, but makes it fairly straight forward to communicate and address errors if one occurs.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The second experience does ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'not'
	      ),
	      ' ask the user to wait, but it does makes error handling more difficult, and can also make the application feel unresponsive and "broken" depending on how long the request takes.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A third option is to ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'display changes to data as soon as they\'re submitted'
	      ),
	      ', meaning that when the user creates data, you insert into the application immediately, and if they update or delete data, you show that change as if it\'s instantaneous.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This type of experience is referred to as an "optimistic update" because we\'re optimistic the request will be successful, and are comfortable showing the user an experience that assumes it will be.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'It\'s not appropriate for all situations, and it doesn\'t necessarily make error handling any easier, but it can provide a feeling of responsiveness to the application. And that\'s what we\'ll be exploring in this section.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Ready? Let\'s ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-1/' },
	        'get started'
	      ),
	      '!'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-optimistic-overview-js-93fcfe238074c87114fc.js